RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _, s, companyDisplay, CompareData) {

    'use strict';

    const ContentListItem = views.ContentListItem = Marionette.ItemView.extend({
        className: 'panel-body',
        truncateLength: 150,
        behaviors: {
            ImageExpander: {}
        },

        baseUi: {
            statDetailsLink: '.x-show-stat-details',
            engagementTrigger: '.x-engagement-trigger',
            secondaryTrigger: '.x-secondary-trigger',
            statDetails: '.x-stat-details',
            expandableDescription: '.x-description.pointer',
            expandTriggers: '.pointer',
            expandable: '.collapse',
            toggleable: '.x-toggle',
            tooltips: '[data-toggle="tooltip"]'
        },

        baseEvents: {
            'click': 'showDetails'
        },

        showDetails: function (e) {
            // Don't expand when the user clicks a link
            // Cant stop propagation b/c we want to bubble the click
            // event to the shell
            const $target = $(e.target);
            if ($target.is('a') || $target.parent('a').length) {
                return;
            }

            const me = this;
            me.ui.expandable.collapse('toggle');
            me.ui.toggleable.toggle();
            me.$el.toggleClass('expanded');
        },

        showMore: function (e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            const me = this;
            me.ui.more.dropdown('toggle');
        },

        onRender: function () {
            const me = this;

            me.ui.expandable.on('shown.bs.collapse', function () {
                App.trigger('contentListItem:sizeChange');
            });

            me.ui.tooltips.tooltip();
        },

        onShow: function () {
            const me = this;

            me.ui.engagementTrigger.popover({
                content: new Marionette.ItemView({
                    template: '#engagementRatePopoverTemplate',
                    model: me.model,
                    templateHelpers: me.templateHelpers()
                }).render().el,
                title: 'Engagement Rate',
                trigger: 'hover',
                placement: 'auto',
                container: 'body',
                html: true
            });
        },

        getPopoverTemplate: function () {
            const me = this;

            switch (me.getMetric().name) {
                case 'engagement_total':
                    return '#engagementTotalPopoverTemplate';
                default:
                    return '#secondaryMetricPopoverTemplate';
            }
        },

        isCrossChannel: function () {

            const me = this;
            return (me.getOption('source') === CompareData.sources.CROSS_CHANNEL);
        },

        templateHelpers: function () {

            const me = this;
            const metric = me.getMetric();
            const sourceDetails = me.getSourceDetails();
            const channelData = me[`${sourceDetails.channel}TemplateHelpers`]();
            const fromOptions = _.pick(me.options, 'index', 'channel', 'isLandscapeComparison', 'sourceDetails', 'engagements');

            const data = {
                index: 1,
                s: s,
                sourceDetails: sourceDetails,
                crossChannel: me.isCrossChannel(),
                sourceName: sourceDetails.name,
                metric: me.model.get(metric.name),
                metricName: metric.name,
                metricDisplayName: me.getMetricDisplayName(),
                iconUrl: me.getIconUrl(),
                truncateLength: me.getOption('truncateLength'),
                comparedTo: (me.options.isLandscapeComparison ? 'Landscape' : 'Company'),
                numberFormatter: RivalIQ.formatter.formats.number,
                rateFormatter: RivalIQ.formatter.absolutePercent,
                comparisonFormatter: RivalIQ.formatter.formatDecimal,
                isRestricted: me.model.get('is_restricted'),
                engagements: _.map(sourceDetails.engagementTypeMappings, function (type) {
                    type.value = me.model.get(type.name);
                    return type;
                }),
                audienceMetrics: [{
                    displayName: sourceDetails.reachName,
                    value: me.model.get('presence_reach')
                }],
                channelSpecific: {},
                getResponsiveLineBreak: _.bind(me.getResponsiveLineBreak, me)
            };

            return _.extend(data, channelData, fromOptions, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        getSourceDetails: function () {

            const me = this;
            const model = me.model;
            return CompareData.sourceDetails[model.get('source')];
        },

        getMetric: function () {

            const me = this;
            const sort = me.getOption('sort');
            const sourceDetails = me.getSourceDetails();
            const defaultMetric = {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            };

            if (!sort) {

                return defaultMetric;
            }

            // Special case for sorting by engagement_rate and date. Since Engagement
            // rate is always present, we display Engagement Total as the
            // metric instead
            switch (sort.name) {
                case 'engagement_rate':
                case 'published_at':
                    return defaultMetric;
                default:
                // Refind to map collection specific sorts (like cross
                // channel's applause) to the channel specific sort
                    return _.find(sourceDetails.validContentSortOrders, {
                        name: sort.name
                    }) || defaultMetric;
            }
        },

        getIconUrl: function () {
            const me = this;
            const model = me.model;
            const companyId = model.get('company_id');

            return me.options.companyData.get(companyId).getIcon(model.get('source'));
        },

        twitterTemplateHelpers: function () {
            const me = this;
            const model = me.model.toJSON();

            const tweetType = me.model.get('type');
            const isRetweetOrReply = (tweetType === App.enums.tweetTypes.retweet.id || tweetType === App.enums.tweetTypes.reply.id);
            const tweetTypeName = _.find(App.enums.tweetTypes, {
                id: tweetType
            }).name;

            return {
                company_name: `${model.company_name} (@${model.presence_handle})`,
                presence_handle: `@${model.presence_handle}`,
                channelSpecific: {
                    isRetweetOrReply: isRetweetOrReply,
                    tweetTypeName: tweetTypeName
                }
            };
        },

        facebookTemplateHelpers: function () {
            return {};
        },

        youtubeTemplateHelpers: function () {
            return {};
        },

        instagramTemplateHelpers: function () {
            return {};
        },

        linkedinTemplateHelpers: function () {
            return {};
        },

        constructor: function () {
            const me = this;

            // Extend ui hashes to allow for easy subclassing
            me.ui = _.extend({}, me.baseUi, me.itemUi);
            me.events = _.extend({}, me.baseEvents, me.itemEvents);
            Marionette.ItemView.prototype.constructor.apply(this, arguments);
        },

        getLineBreak: function () {

            return $.tagHtml('br', {
                class: ['hidden-xs']
            });
        },

        getResponsiveLineBreak: function () {

            const me = this;

            return $.tagHtml('span', {
                html: [
                    me.getLineBreak(),
                    $.tagHtml('span', {
                        class: ['visible-xs-inline'],
                        html: '&nbsp;'
                    })
                ].join('')
            });
        },

        getMetricDisplayName: function () {

            const me = this;
            const metric = me.getMetric();
            const metricDisplayName = metric.displayName;
            const metricDisplayNameParts = metricDisplayName.split(' ');

            // NOTE we have to special case metric display names that do not
            // contain spaces. the reason being that they need to appear as
            // though they take up two lines, which is why we talk on some of
            // our line breaks to the end (it requires two BRs, and P does not
            // suffice)
            return (metricDisplayNameParts.length === 1 ?
                [metricDisplayName, me.getLineBreak(), me.getLineBreak()].join('') :
                metricDisplayNameParts.join(me.getResponsiveLineBreak()));
        }
    });

    /**
     * Gets a view class by channel and type.
     * @param channel
     * @param type
     */
    ContentListItem.getViewClassByChannelType = function (channel, type) {

        if (channel === 'linkedin') {
            if (type.toLowerCase() === 'video') {
                return views.LinkedInVideoListItem;
            } else {
                return views.PhotoListItem;
            }
        }

        switch (type) {
            case 'status':
                return views.StatusListItem;
            case 'link':
            case 'offer':
                return views.LinkListItem;
            case 'photo':
                return views.PhotoListItem;
            case 'video':
                return views.VideoListItem;
            case 'job':
                return views.JobListItem;
            default:
                return views.UnknownListItem;
        }
    };

    ContentListItem.getView = function (model) {
        const channel = CompareData.sourceDetails[model.get('source')];
        const type = _.get(model.get('rivaliq'), 'display.type');
        const View = ContentListItem.getViewClassByChannelType(channel, type);

        return new View({
            model: model,
            companyData: model.company.collection
        });
    };

}, window.s, RivalIQ.utils.companyDisplay, RivalIQ.data.CompareData);
